import * as React from "react";
import styles from "./Button.module.scss";
import {PropsWithChildren} from "react";

interface IButtonProps {
  // Event|undefined if preventDefault needed (ie Forms)
  action?: (evt: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  type?: ButtonType;
  styles?: ButtonStyles[];
  btnIdentifier?: string | number;
  as?: "link";
  href?: string;
}

// TODO Vllt nochmal 'ButtonStates' einführen, und ButtonType dann für FB, AMAZON, GPAY & PAYPAL benutzen
export enum ButtonType {
  default = "button--primary",
  outlined = "button--outlined",
  disabled = "button--disabled",
}

export enum ButtonStyles {
  wide = "button--wide",
  big = "button--big",
  datepicker = "datepicker",
}

export const Button: React.FC<PropsWithChildren<IButtonProps>> = (props) => {
  const type = props.type || ButtonType.default;
  const propsStyles = props.styles || [];
  const className = styles[type] + " " + propsStyles.map((bs) => styles[bs]).join(" ");

  const disabled = type === ButtonType.disabled;

  if (props.as === "link") {
    return (
      <a
        className={className}
        data-btn-identifier={props.btnIdentifier}
        href={props.href}
        target={"_blank"}
        rel={"noreferrer"}
      >
        {props.children}
      </a>
    );
  }

  return (
    <button className={className} onClick={props.action} disabled={disabled} data-btn-identifier={props.btnIdentifier}>
      {props.children}
    </button>
  );
};
